import { Button } from 'antd';

import type { TaskId } from '/imports/domain';
import { MainContent } from '/imports/ui/components/MainContent';
import { VStack } from '/imports/ui/foundation/Layout';
import type { QuizAttemptId } from '../../domain';
import type { PublicQuiz } from '../../domain/PublicQuiz';
import type { SolveQuizApi } from './SolveQuizApi';

export const SolveQuizSummary = (_: {
  api: SolveQuizApi;
  taskId: TaskId;
  attemptId: QuizAttemptId;
  quiz: PublicQuiz;
}) => (
  <MainContent title="Summary">
    <VStack gap="xl" align="start" style={{ maxWidth: 640 }}>
      Info about quiz status
      <Button type="primary" onClick={() => console.log('TODO: Implement submit (cx-4161)')}>
        Submit …
      </Button>
    </VStack>
  </MainContent>
);
